import React from 'react';

import { Card, CardHeader, Grid, Typography, Button, Checkbox, CardContent } from '@material-ui/core';
import { mdiPlusCircle } from '@mdi/js';
import classes from '../../../pages/createOrder/index.module.scss';
import List from '../../../pages/createOrder/components/list';
import VitrinList from '../../../pages/createOrder/components/listVitrin';
import Icon from '@mdi/react';

const vitrin = localStorage.getItem('vitrin') || null;

function ProductList(props: any) {
    const { setDialog, itemsInfo, setConfirmDelete, isVitrinOrderItem, setIsVitrinOrderItem } = props;

    return (
        <Card className={classes.card}>
            <CardContent
                className={classes.cardContentOrder}
                style={{ padding: '0' }}
            >
                <Grid container justifyContent='flex-end'>
                    <Button
                        variant="outlined"
                        className={classes.addProductIcon}
                        style={{ marginBottom: "24px" }}
                        color="primary"
                        size="large"
                        endIcon={<Icon path={mdiPlusCircle} size={'17px'} />}
                        onClick={() => {
                            isVitrinOrderItem
                                ? setDialog('openAddVitrinItem')
                                : setDialog('openAddItem')
                        }}
                        data-cy="addProduct"
                    >
                        {'افزودن کالا به سفارش'}
                    </Button>
                </Grid>
                {vitrin && <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    alignItems="flex-start"
                >
                    <div className={classes.item}>
                        <span className={classes.label}>
                            <Checkbox
                                checked={isVitrinOrderItem}
                                onChange={e => {
                                    setIsVitrinOrderItem(e.target.checked);
                                }}
                                color="secondary"
                                inputProps={{
                                    'aria-label': 'secondary checkbox',
                                }}
                                data-cy="fulfillmentServiceCheckBox"
                            />
                        </span>

                        <div
                            style={{
                                width: '100%',
                                marginTop: '20px',
                            }}
                        >
                            <span>این سفارش از کالاهای ویترین فروشندگان دیگر است</span>
                        </div>
                    </div>
                </Grid>}
                {itemsInfo.length > 0 && (
                    <Grid style={{ padding: '0', margin: '0' }}>
                        {
                            isVitrinOrderItem ? (
                                <VitrinList
                                    data={itemsInfo}
                                    deleteItem={(body: any) => setConfirmDelete(body)}
                                />
                            ) : (
                                <List
                                    data={itemsInfo}
                                    deleteItem={(body: any) => setConfirmDelete(body)}
                                />
                            )
                        }
                    </Grid>
                )}
            </CardContent>
        </Card>
    )
}

export default ProductList;